(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crisalide-news"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('crisalide-news')) {
  customElements.define('crisalide-news', class extends HTMLElement {
    connectedCallback() {
      if(this.ready) return;
      this.ready=true;
      this.slides=[...this.querySelectorAll('[data-slide]')];
      this.dots=[...this.querySelectorAll('[data-dot]')];
      this.index=0;
      this.paused=this.dataset.autoplay!=='true'||matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.abort=new AbortController();
      const on=(el,event,fn)=>el.addEventListener(event,fn,{signal:this.abort.signal});
      this.pauseButton=this.querySelector('[data-pause]');
      if(this.slides.length<2)return;
      this.querySelector('.cn-news__controls').hidden=false;
      on(this.querySelector('[data-prev]'),'click',()=>this.manual(this.index-1));
      on(this.querySelector('[data-next]'),'click',()=>this.manual(this.index+1));
      this.dots.forEach((dot,i)=>on(dot,'click',()=>this.manual(i)));
      on(this.pauseButton,'click',()=>{this.paused=!this.paused;this.label();this.start();});
      on(this,'mouseenter',()=>{this.hovering=true;this.stop();});
      on(this,'mouseleave',()=>{this.hovering=false;this.start();});
      on(this,'focusin',()=>this.stop());
      on(this,'focusout',()=>setTimeout(()=>this.start(),0));
      on(document,'visibilitychange',()=>this.start());
      on(this,'keydown',e=>{if(e.key==='ArrowRight'){e.preventDefault();this.manual(this.index+1);}if(e.key==='ArrowLeft'){e.preventDefault();this.manual(this.index-1);}});
      on(this,'touchstart',e=>{this.touchX=e.changedTouches[0].clientX;this.touchY=e.changedTouches[0].clientY;});
      on(this,'touchend',e=>{const dx=e.changedTouches[0].clientX-this.touchX,dy=e.changedTouches[0].clientY-this.touchY;if(Math.abs(dx)>55&&Math.abs(dx)>Math.abs(dy))this.manual(this.index+(dx<0?1:-1));});
      on(document,'shopify:block:select',e=>{const selected=this.slides.findIndex(slide=>slide.contains(e.target));if(selected>=0)this.manual(selected);});
      this.label();this.show(0);this.start();
    }
    show(index){this.index=(index+this.slides.length)%this.slides.length;this.slides.forEach((slide,i)=>{slide.hidden=i!==this.index;});this.dots.forEach((dot,i)=>dot.setAttribute('aria-pressed',String(i===this.index)));}
    manual(index){this.paused=true;this.stop();this.show(index);this.label();}
    label(){this.pauseButton.textContent=this.paused?this.pauseButton.dataset.playLabel:this.pauseButton.dataset.pauseLabel;}
    stop(){clearInterval(this.timer);}
    start(){this.stop();if(this.paused||this.hovering||document.hidden||this.contains(document.activeElement))return;this.timer=setInterval(()=>this.show(this.index+1),Number(this.dataset.speed)||7000);}
    disconnectedCallback(){this.stop();this.abort?.abort();this.ready=false;}
  });
}

  } catch(e) { console.error(e); }
})();
})();
